export default __webpack_public_path__ + "static/media/logo-connect-subtitle.529b0545.png";